import { useTranslation } from "@fanfanlo";
import { OpenBrowserButton } from "./OpenBrowserButton";
import { browserUtils } from "./data";

export function DocMainPage(){
    const {t} = useTranslation('homepage/components/browser/content')
    return (
        <OpenBrowserButton url={browserUtils.getUrl("")} name={t("DocMainPage.mainPage")} />
    )
}